"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ebooksDetailed = void 0;
require("qtip2");
const jquery_1 = __importDefault(require("jquery"));
exports.ebooksDetailed = {
    init() {
        (0, jquery_1.default)('.help_programeles, .help_formatai').each(function () {
            const $text = (0, jquery_1.default)(this).next('.tooltiptext');
            const $title = $text.find('p:first > strong').hide().text();
            (0, jquery_1.default)(this).qtip({
                content: {
                    title: $title,
                    text: $text,
                },
                position: {
                    my: 'top center',
                    at: 'center center',
                },
                hide: {
                    fixed: true,
                    delay: 300,
                },
                style: {
                    classes: 'qtip-blue',
                },
            });
        });
    },
};
